
// MARK: Simplified interviewer
// NOTE(IAS): Move to interviewer folders?
export interface IInterviewer {
    id: number;
    agencyId: number;
    profileUrl: string;
    firstName: string;
    lastName: string;
}

// MARK: Interview
// May be event or standard interview
// NOTE(IAS): Do we want to distinguish online vs in-person still?
export enum InterviewType {
    Interview,
    InterviewOnline,
    CDFair,
}

export interface IInterview {
    id: number;
    interviewType: InterviewType;
    interviewDate: string;
    interviewTime: string;
    recommended: boolean;
}

// MARK: Interview report
export interface IInterviewReport {
    id: number;
    whyCamp: string;
    nonStudentSkills: string;
    firstImpression: string;
    personality: string;
    additionalInfo: string;
    relationshipWithFamily: string;
    yourFriends: string;
    childcare: string;
    childcareExperience: string;
    behaviour: string;
    safeguarding: string;
    particularCamp?: string;
    lookingForwardToInUS: string;
    applicableSkills?: string;
    understandRole?: string;
    familyInterestsHobbies?: string;
}

// MARK: All interview-related
export interface IApplicationInterview {
    interviewer?: IInterviewer;
    interview?: IInterview;
    report?: IInterviewReport;
}

// // MARK: Experience
// export interface IApplicantExperience {
//     childcareExperience?: string;
//     familyInterestsHobbies?: string;        // experience conditions
//     understandRole?: string;                // Either counsellor or campower role
// }